function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-15.42 3069.316 1800 1800",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2",
    transform: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 1280.601 L 1771.16 1280.601 L 1771.16 0 L 0 0 Z",
    style: {
      fill: "none",
      clipRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, -1, -0.000035, 4608.616699)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 13.420078, 7.424438)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -28.84 -268.124 L 1771.16 -268.124 L 1771.16 1531.876 L -28.84 1531.876 L -28.84 -268.124 Z",
    style: {
      fill: "rgb(17, 141, 47)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 884.580078, 1147.411987)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 112.798 L 776.404 -508.111 L 0 -1129.021 L -776.404 -508.111 L 0 112.798 Z",
    style: {
      fill: "rgb(255, 221, 0)",
      fillRule: "evenodd",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(884.5801 967.0391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 181.005 0 327.738 -146.733 327.738 -327.738 C 327.738 -508.744 181.005 -655.478 0 -655.478 C -181.005 -655.478 -327.739 -508.744 -327.739 -327.738 C -327.739 -146.733 -181.005 0 0 0",
    style: {
      fill: "rgb(0, 50, 166)",
      fillRule: "evenodd",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(647.9834 802.2305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 214.718 0 410.903 -79.28 560.937 -210.135 C 556.826 -238.637 549.057 -265.953 538.104 -291.589 C 398.334 -157.781 208.773 -75.563 0 -75.563 C -27.169 -75.563 -54.01 -76.966 -80.461 -79.683 C -73.207 -51.993 -62.426 -25.731 -48.622 -1.408 C -32.525 -0.504 -16.322 0 0 0",
    style: {
      fill: "rgb(254, 254, 254)",
      fillRule: "evenodd",
      fillOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/br.a00f5f506123eddb6d1eaac0aaa9f593.svg";
export { ForwardRef as ReactComponent };